import { Avatar } from '@/components/ui/avatar';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button/button.tsx';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown/dropdown-menu.tsx';
import { clsx } from '@/lib/utils';
import { useGetCurrentUserInfoQuery } from '@/redux/queries/users';
import { RiMenuUnfoldFill } from 'react-icons/ri';
import { useTranslation } from 'react-i18next';
import { UserUtils } from '@/utils/user.utils.ts';
import { useState } from 'react';
import ChangePassword from '@/components/ChangePassword';
import Tooltip from '@mui/material/Tooltip';
import { EnvironmentBanner } from '@/components/environment-banner/EnvironmentBanner.tsx';
import { useAuth } from 'react-oidc-context';
import { useUserPreferencesStore } from '@/store/user-preferences.store';
import { Menu } from 'lucide-react';

const Navbar = () => {
    const [t] = useTranslation();
    const { data: currentUserInfo } = useGetCurrentUserInfoQuery();
    const [showPasswordChangeModal, setShowPasswordChangeModal] = useState(false);
    const auth = useAuth();
    const setSidebarCollapsed = useUserPreferencesStore((state) => state.setSidebarCollapsed);
    const sidebarCollapsed = useUserPreferencesStore((state) => state.sidebarCollapsed);

    const handleLogout = async () => {
        await auth.signoutRedirect();
    };

    return (
        <>
            <header className="bg-background relative  border-l top-0 overflow-hidden w-full flex items-center justify-between px-4 h-16 z-10">
                <div className="flex items-center gap-3">
                    <Tooltip
                        title={t(`general.${sidebarCollapsed ? 'openNav' : 'closeNav'}`)}
                        placement={'right'}>
                        <Button
                            onClick={() => {
                                console.log('clicked');
                                setSidebarCollapsed(
                                    !useUserPreferencesStore.getState().sidebarCollapsed,
                                );
                            }}
                            size="icon"
                            variant="ghost"
                            className="hidden md:inline-flex hover:bg-transparent hover:text-primary2 text-primary">
                            <RiMenuUnfoldFill
                                className={clsx(
                                    'text-xl rotate-180',
                                    sidebarCollapsed && 'rotate-0',
                                )}
                            />
                        </Button>
                    </Tooltip>

                    <div className="hidden md:block">
                        <EnvironmentBanner />
                    </div>

                    <button
                        type="button"
                        className="shadow-lg rounded-full p-2 bg-gray-100 text-gray-600 cursor-pointer md:hidden"
                        onClick={() => {
                            console.log('clicked');
                            setSidebarCollapsed(false);
                        }}>
                        <Menu className="size-4" />
                    </button>

                    <div className="md:hidden">
                        <EnvironmentBanner />
                    </div>
                </div>
                <div className="flex items-center justify-center gap-4 h-full">
                    {currentUserInfo?.houseManagementData.wwuNumber && (
                        <>
                            <Badge variant={'slate'}>
                                {currentUserInfo?.houseManagementData.wwuNumber}
                            </Badge>
                            <div className={'bg-border h-9 w-px '} />
                        </>
                    )}
                    <div className="flex items-center">
                        <DropdownMenu>
                            <DropdownMenuTrigger className="active:outline-0 focus:outline-0 after:outkine-0">
                                <span className="flex items-center gap-3">
                                    <Avatar
                                        getFallback={() =>
                                            (currentUserInfo &&
                                                UserUtils.getUserInitials(currentUserInfo)) ??
                                            ''
                                        }
                                    />
                                    <div className="hidden md:flex items-center gap-4">
                                        <div className="flex flex-col items-start font-semibold hover:text-primary2">
                                            <span className="text-sm">
                                                {currentUserInfo?.firstName}{' '}
                                                {currentUserInfo?.lastName}
                                            </span>
                                            {currentUserInfo?.userRole && (
                                                <span className="text-xs text-slate-500">
                                                    {t(`users.role.${currentUserInfo.userRole}`)}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </span>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent align="start">
                                <DropdownMenuItem onClick={() => setShowPasswordChangeModal(true)}>
                                    {t('user.actions.changePassword')}
                                </DropdownMenuItem>
                                <DropdownMenuItem onClick={handleLogout}>
                                    {t('user.actions.logout')}
                                </DropdownMenuItem>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </div>
                </div>
            </header>
            <ChangePassword
                open={showPasswordChangeModal}
                onClose={() => setShowPasswordChangeModal(false)}
            />
        </>
    );
};

export default Navbar;
